import { quantizeEditorAuthoredPt } from '@messenger/lotus'

export const formatPt = (pt: number): string =>
  String(quantizeEditorAuthoredPt(pt))
